import React from "react";
import { connect } from "react-redux";
import { getProfile, editProfile } from "../../actions/user";
import { USER_ROLES } from "../../utils/constant";
import { getRole, capitalize } from "../../utils/tools";
import {
  Container,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Button,
  FormGroup,
  UncontrolledAlert
} from "reactstrap";
import ReactCrop from "react-image-crop";
import TextEditor from "../../components/Commons/TextEditor";
import ArticleForm from "../../components/profile/ArticleForm";
import OverlayLoading from "../../components/Commons/OverlayLoading.jsx";
import moment from "moment";
import { DOMAIN } from "../../utils/constant";
import { Link } from "react-router-dom";
class ProfileEditPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      article: {},
      crop: {
        unit: "%",
        width: 30,
        aspect: 10 / 10
      },
      src: null,
      croppedImageUrl: null,
      editable: false
    };
    this.onTextInputChange = this.onTextInputChange.bind(this);
    this.onContentChange = this.onContentChange.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
    this.onImageLoaded = this.onImageLoaded.bind(this);
    this.onCropComplete = this.onCropComplete.bind(this);
    this.onCropChange = this.onCropChange.bind(this);
    this.onSelectFile = this.onSelectFile.bind(this);

    this.makeClientCrop = this.makeClientCrop.bind(this);
    this.getCroppedImg = this.getCroppedImg.bind(this);
    this.confirmImg = this.confirmImg.bind(this);
    this.submitArticle = this.submitArticle.bind(this);
  }

  componentDidMount() {
    this.props.getProfile();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.user.selectedUser !== this.props.user.selectedUser) {
      let article = newProps.user.selectedUser;
      if (article.profile_photo) {
        this.setState({ croppedImageUrl: DOMAIN + article.profile_photo });
      }

      this.setState({
        article: article
      });
    }
  }

  onTextInputChange(e, target) {
    let value = e.target.value;
    let article = this.state.article;
    article[target] = value;
    this.setState({
      article: article
    });
  }

  onContentChange(model) {
    let value = model;
    let article = this.state.article;
    article["body"] = value;
    this.setState({
      article: article
    });
  }

  handleCheckBoxChange(e) {
    const { value } = e.target;
    let article = this.state.article;
    let category_ids = [];
    category_ids.push(value);
    this.setState({
      article: {
        ...article,
        category_ids
      }
    });
  }

  onSelectFile = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        this.setState({ src: reader.result })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
    this.setState({
      editable: true
    });
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = image => {
    this.imageRef = image;
  };

  onCropComplete = crop => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    //图片缩放
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    /**
    
     * 画布大小
     */
    // 图片原始尺寸
    var originWidth = crop.width * scaleX;
    var originHeight = crop.height * scaleY;
    // 最大尺寸限制
    var maxWidth = 1200,
      maxHeight = 1200 / (16 / 9);
    // 目标尺寸
    var targetWidth = originWidth,
      targetHeight = originHeight;
    // 图片尺寸超过1200x1200的限制
    if (originWidth > maxWidth || originHeight > maxHeight) {
      if (originWidth / originHeight > maxWidth / maxHeight) {
        // 更宽，按照宽度限定尺寸
        targetWidth = maxWidth;
        targetHeight = Math.round(maxWidth * (originHeight / originWidth));
      } else {
        targetHeight = maxHeight;
        targetWidth = Math.round(maxHeight * (originWidth / originHeight));
      }
    }
    // canvas对图片进行缩放
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image, //原始图片
      crop.x * scaleX, //x-axis coordinate of  top left corner of source image
      crop.y * scaleY, //y-axis coordinate of top left corner of source image
      crop.width * scaleX, //the width of the sub-rectangle of the source image
      crop.height * scaleY, //the height of the sub-rectangle of the source image
      0, //x-axis coordinate in the destination canvas at which to place the top-left corner of the source image.
      0, //y-axis coordinate in the destination canvas at which to place the top-left corner of the source image.
      targetWidth, //The width to draw the image in the destination canvas. This allows scaling of the drawn image.
      targetHeight //The height to draw the image in the destination canvas. This allows scaling of the drawn image.
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        blob => {
          if (!blob) {
            console.error("Canvas is empty");
            return;
          }
          blob.name = fileName;
          this.setState({
            file: blob
          });
          window.URL.revokeObjectURL(this.fileUrl);
          this.fileUrl = window.URL.createObjectURL(blob);
          resolve(this.fileUrl);
        },
        "image/png",
        1
      );
    });
  }

  confirmImg() {
    this.setState({
      editable: false
    });
    this.submitArticle("avatar");
  }

  formatTime(dateString) {
    return moment(dateString).format("YYYY-MM-DD");
  }

  submitArticle(type) {
    let { article, file } = this.state;
    const name = article.name;
    const pseudonym = article.pseudonym;
    const email = article.email;
    const phone = article.phone;
    const original_password = article.original_password;
    const new_password = article.new_password;
    const new_password_confirmation = article.new_password_confirmation;
    const avatar = file;
    this.props.editProfile({
      name,
      pseudonym,
      email,
      phone,
      original_password,
      new_password,
      new_password_confirmation,
      avatar,
      type
    });
  }

  render() {
    const { crop, croppedImageUrl, src, editable } = this.state;
    let {
      getUserRequest,
      errorMsg,
      errors,
      editUserRequest,
      successBackMsg
    } = this.props.user;
    const coverImg = this.state.croppedImageUrl
      ? this.state.croppedImageUrl
      : DOMAIN + "resources/cloud-upload-light.png";
    var sectionStyle = {
      width: "100%",
      paddingBottom: "100%",
      height: "0",
      border: "1px solid #ccc",
      borderRadius: "50%",
      background:
        'url("' +
        coverImg +
        '") center center / cover no-repeat rgb(255, 255, 255)'
    };
    var fileInputStyle = {
      position: "absolute",
      opacity: 0,
      right: 0,
      top: 0,
      bottom: 0,
      left: 0,
      filter: "alpha(opacity = 0)",
      cursor: "pointer"
    };
    var uploadBtnWrapper = {
      position: "relative",
      display: "block",
      borderRadius: "6px",
      cursor: "pointer"
    };

    return (
      <Container className="mt-4" fluid>
        {errorMsg && (
          <UncontrolledAlert color="danger" fade={false}>
            <span className="alert-inner--text">{errorMsg}</span>
          </UncontrolledAlert>
        )}
        {successBackMsg && (
          <UncontrolledAlert color="success" fade={false}>
            <span className="alert-inner--text mb-4">{successBackMsg}</span>
          </UncontrolledAlert>
        )}
        <div className="row flex-start">
          <Card className="card-frame col-md-6">
            <CardHeader className="border-0">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <h3>個人資料</h3>
                </div>
                <div className="d-flex align-items-center"></div>
              </div>
            </CardHeader>
            <OverlayLoading loading={getUserRequest}>
              <CardBody>
                <div className="px-4">
                  <ArticleForm
                    data={this.state.article}
                    onTextInputChange={this.onTextInputChange}
                    handleCheckBoxChange={this.handleCheckBoxChange}
                    submitArticle={this.submitArticle}
                    loading={editUserRequest}
                  />

                  <div className="d-flex align-items-center justify-content-around">
                    <button
                      type="button"
                      className="btn btn-default"
                      style={{ flex: 1 }}
                      disabled={editUserRequest}
                      onClick={this.submitArticle}
                    >
                      保存
                    </button>
                  </div>
                </div>
              </CardBody>
            </OverlayLoading>
          </Card>

          <Card className="card-frame col-md-3 align-self-start ml-4 mw-300">
            <OverlayLoading loading={getUserRequest}>
              <CardBody className="p-4">
                <div className="d-flex flex-column align-items-center">
                  {src && editable && (
                    <ReactCrop
                      src={src}
                      crop={crop}
                      onImageLoaded={this.onImageLoaded}
                      onComplete={this.onCropComplete}
                      onChange={this.onCropChange}
                    />
                  )}
                  {!editable && (
                    <div style={{ width: "100%", padding: "20px" }}>
                      <div style={sectionStyle}></div>
                    </div>
                  )}
                  <div className="d-flex flex-row my-2">
                    {editable && (
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={this.confirmImg}
                      >
                        確認
                      </button>
                    )}
                    <div style={uploadBtnWrapper}>
                      <button
                        type="button"
                        style={{ cursor: "pointer" }}
                        block={true}
                        className="btn btn-secondary btn-sm"
                      >
                        更換頭像
                      </button>
                      <input
                        style={fileInputStyle}
                        type="file"
                        onChange={this.onSelectFile}
                        accept="image/x-png,image/gif,image/jpeg"
                      />
                    </div>
                  </div>
                </div>
              </CardBody>
              <CardFooter className="text-center">
                <h4>{this.state.article.name}</h4>
                <span>{this.state.article.email}</span>
              </CardFooter>
            </OverlayLoading>
          </Card>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    location: state.router.location,
    pathname: state.router.location.pathname,
    search: state.router.location.search
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getProfile: params => dispatch(getProfile(params)),
    editProfile: params => dispatch(editProfile(params))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileEditPage);
